import { PATH } from '@/constants/path';
import { Button, ButtonGroup, Frame, Link, Page, PageProps } from '@shopify/polaris';
import {
  BookIcon,
  HomeIcon,
  LanguageTranslateIcon,
  PersonLockIcon,
  PriceListIcon,
  SettingsIcon,
  ShieldCheckMarkIcon,
} from '@shopify/polaris-icons';
import { memo, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useLocation, useNavigate } from 'react-router-dom';
import RegularText from '../RegularText';
import SkeletonPage from '../SkeletonPage';
import Toast from '../Toast/Toast';
import { LayoutStyled } from './styled';
import ModalReview from '@/components/ModalReview';
import { LINKS } from '@/constants';

interface ILayoutProps extends PageProps {
  headers?: React.ReactNode;
  isBigHeader?: boolean;
  isFullWidth?: boolean;
}

const Layout = ({ ...props }: ILayoutProps): JSX.Element => {
  const location = useLocation();
  const navigate = useNavigate();
  const { t } = useTranslation('common');
  const isLoading = false;

  const btnGroup = [
    {
      content: t('dashboard'),
      icon: HomeIcon,
      path: PATH.DEFAULT,
    },
    {
      content: t('store_verification'),
      icon: PersonLockIcon,
      path: PATH.POP_UP_CUSTOMIZATION,
    },
    // {
    //   content: t('checkout_verification'),
    //   icon: HomeIcon,
    //   path: PATH.CHECKOUT_VERIFICATION,
    // },
    {
      content: t('terms_conditions'),
      icon: ShieldCheckMarkIcon,
      path: PATH.TERM_AND_CONDITION,
    },
    {
      content: t('translation'),
      icon: LanguageTranslateIcon,
      path: PATH.TRANSLATION,
    },
    {
      content: t('setting'),
      icon: SettingsIcon,
      path: PATH.SETTINGS,
    },
    {
      content: t('pricing'),
      icon: PriceListIcon,
      path: PATH.PRICING_PLAN,
    },
  ];

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [location.pathname]);

  return (
    <LayoutStyled isBigHeader={props.isBigHeader} isFullWidth={props.isFullWidth}>
      <Frame>
        <Toast />

        <div className="nav-bar">
          <ButtonGroup fullWidth gap="extraTight">
            {btnGroup.map((item, index) => {
              return (
                <Button
                  key={index}
                  icon={item.icon}
                  variant={
                    location.pathname === item?.path?.pathname || (index === 0 && location.pathname === '/')
                      ? 'primary'
                      : undefined
                  }
                  onClick={() => {
                    navigate({
                      ...item.path,
                    });
                  }}
                >
                  {item.content}
                </Button>
              );
            })}
            <Button
              icon={BookIcon}
              onClick={() => {
                window.open('https://help.omegatheme.com/en/category/blockify-age-verification-18-10ycadj/', '_blank');
              }}
            >
              Documentation
            </Button>
          </ButtonGroup>
        </div>

        {props.headers || null}
        <Page {...props}>
          {isLoading ? (
            <SkeletonPage />
          ) : (
            <div>
              <div>{props.children}</div>
              <RegularText>
                <div className="layout-footer">
                  <RegularText>
                    Share your experience with Age Verification here{' '}
                    <Link external url={LINKS.WIX_REVIEW}>
                      leave a review
                    </Link>
                  </RegularText>
                </div>
              </RegularText>
              {/* <RegularText>
                <div className="layout-footer">
                  {t('please_view')}&nbsp;{' '}
                  <Link
                    removeUnderline
                    target="_blank"
                    url="https://help.omegatheme.com/en/category/blockify-age-verification-18-10ycadj/"
                  >
                    {t('our_document_guideline')}
                  </Link>
                </div>
              </RegularText> */}
            </div>
          )}
        </Page>
      </Frame>
      <ModalReview />
    </LayoutStyled>
  );
};
export default memo(Layout);
